import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { FieldArray } from "formik";

export const FormNhap = ({ values, errors, setFieldValue }) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <div className="title-page-cau-hinh-hien-thi">
          Cấu hình hiển thị thông tin truy xuất nguồn gốc
        </div>
        <FieldArray
          name="fieldChucNangs"
          render={arrayHelpers => (
            <Grid container spacing={1} style={{ marginLeft: "10px" }}>
              {values?.fieldChucNangs?.map((item, index) => (
                <Grid item xs={12} key={index}>
                  <FormControlLabel
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "300px",
                      alignItems: "center"
                    }}
                    control={
                      <Checkbox
                        checked={values?.fieldChucNangs?.[index]?.isCheck}
                        onChange={event => {
                          setFieldValue(
                            `fieldChucNangs.[${index}].isCheck`,
                            event.target.checked
                          );
                        }}
                      />
                    }
                    label={values?.fieldChucNangs?.[index]?.tenTiengViet}
                    labelPlacement="start"
                  />
                </Grid>
              ))}
            </Grid>
          )}
        />
      </Grid>
    </div>
  );
};
